import { useState } from "react";
import "./company.css";
import CompanyMain from "./company-main";
import CompanyBases from "./company-bases";
import CompanyConditions from "./company-conditions";
import CompanyTokens from "./company-tokens";
import CompanyUsers from "./company-users";
import CompanyBackups from "./company-backups";

const Company = () => {
  const [selectedPage, setSelectedPage] = useState(1);

  const divPagesSelect = [
    <div key="page1" onClick={() => setSelectedPage(1)} className={selectedPage === 1 ? "page-selected" : ""}>Компания</div>,
    <div key="page2" onClick={() => setSelectedPage(2)} className={selectedPage === 2 ? "page-selected" : ""}>Базы</div>,
    <div key="page3" onClick={() => setSelectedPage(3)} className={selectedPage === 3 ? "page-selected" : ""}>Пользователи</div>,
    <div key="page4" onClick={() => setSelectedPage(4)} className={selectedPage === 4 ? "page-selected" : ""}>Маршруты обмена</div>,
    <div key="page6" onClick={() => setSelectedPage(6)} className={selectedPage === 6 ? "page-selected" : ""}>Интеграция</div>,
    <div key="page8" onClick={() => setSelectedPage(8)} className={selectedPage === 8 ? "page-selected" : ""}>Резервные копии</div>,
  ]

  const getPage = () => {
    switch (selectedPage) {
      case 1: return <CompanyMain />
      case 2: return <CompanyBases />
      case 3: return <CompanyUsers />
      case 4: return <CompanyConditions />
      case 6: return <CompanyTokens />
      case 8: return <CompanyBackups />
      default: return null;
    }
  }
  
  return <div className="page">
    <div className="page-select">{divPagesSelect}</div>
    {getPage()}
  </div>
}

export default  Company;